import './viewAllMappingRoutes.css';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { authKey, GET_All_STATE, GET_All_DISTRICT, GET_LIST_POSSIBLE_ROUTES, FETCH_GROWER_HIT_LLE_ROUTE, FETCH_GROWER_HIT_IS_ROUTE, FETCH_LLE_TRANSPORTER_PLANT_ROUTE, FETCH_LLE_TRANSPORTER_IS_ROUTE, FETCH_GROWER_HIT_LLE_TRANSPORTER_PLANT_ROUTE } from '../../../common/URLs';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';

import { loaderService } from "../../../common/custom-loader/loader-service";
import { titleCase } from '../../../common/commonFunction';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { PROD } from '../../../common/constants';
import apiClient from '../../../axios';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

function ViewAllMappingRoutes() {

  const navigate = useNavigate()
  const [details, setDetails] = useState({
    resourceState: '',
    resourceDistrict: '',
    mappingRoute: ""
  });

  const [errorMessage, setErrorMessage] = useState({
    stateError: '',
    districtError: '',
    mappingRouteError: ''
  });
  let [showViewMapedAllDetails, setStakeHolderDetails] = useState(false);
  const [chooseState, setchooseState] = useState([]);
  const [chooseDistrict, setchooseDistrict] = useState([]);
  const [chooseRoute, setChooseRoute] = useState([]);
  const [viewAllRouteDetails, setViewAllRouteDetails] = useState();
  let [showData, setshowData] = useState(false);
  const routelog = useRef(true);
  const statelog = useRef(true);

  useEffect(() => {
    if (statelog.current) {
      statelog.current = false;
      getAllState();
    }
  }, [statelog]);

  useEffect(() => {
    if (routelog.current) {
      routelog.current = false;
      getAllRoutes();
    }
  }, [routelog]);

  function getAllState() {
    loaderService.showLoader();
    apiClient
      .post(GET_All_STATE,
        {

        },
        {
          headers: {
            AuthKey: authKey,
          },
        }
      )
      .then((response) => {
        setchooseState(response.data.stateList);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();

      });
  }

  function getAllDistrict(resourceState) {
    loaderService.showLoader();
    apiClient
      .post(GET_All_DISTRICT,
        {
          "state": resourceState
        },
        {
          headers: {
            AuthKey: authKey,
          },
        }
      )
      .then((response) => {
        setchooseDistrict(response.data.districtLists);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

  function getAllRoutes() {
    loaderService.showLoader();
    apiClient
      .post(GET_LIST_POSSIBLE_ROUTES,
        {
          "serviceType": ""
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        setChooseRoute(response.data.PossibleRouteDropDown);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

  function getGrowerHitLleRoutesData() {
    loaderService.showLoader();
    apiClient
      .post(FETCH_GROWER_HIT_LLE_ROUTE,
        {
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        setViewAllRouteDetails(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

  function getGrowerHitIsRoutesData() {
    loaderService.showLoader();
    apiClient
      .post(FETCH_GROWER_HIT_IS_ROUTE,
        {
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        setViewAllRouteDetails(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

  function getLleTransporterPlantRoutesData() {
    loaderService.showLoader();
    apiClient
      .post(FETCH_LLE_TRANSPORTER_PLANT_ROUTE,
        {
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        setViewAllRouteDetails(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

  function getLleTransporterIsRoutesData() {
    loaderService.showLoader();
    apiClient
      .post(FETCH_LLE_TRANSPORTER_IS_ROUTE,
        {
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        setViewAllRouteDetails(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

  function getGrowerHitLleTransporterPlantRoutesData() {
    loaderService.showLoader();
    apiClient
      .post(FETCH_GROWER_HIT_LLE_TRANSPORTER_PLANT_ROUTE,
        {
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        setViewAllRouteDetails(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

  const handleChange = (e) => {
    e.preventDefault();
    setDetails({ ...details, [e.target.name]: e.target.value });
    if (e.target.name === "resourceState") {
      getAllDistrict(e.target.value)
      setErrorMessage({ ...errorMessage, stateError: "" });
    }
    if (e.target.name === "resourceDistrict") {
      setErrorMessage({ ...errorMessage, districtError: "" });
    }
    if (e.target.name === "mappingRoute") {
      setErrorMessage({ ...errorMessage, mappingRouteError: "" });
    }
  }

  const onProceedRoute = (e) => {
    e.preventDefault();
    if (details.resourceState === '') {
      setErrorMessage({ ...errorMessage, stateError: "Please select state" });
    }
    else if (details.resourceDistrict === '') {
      setErrorMessage({ ...errorMessage, districtError: "Please select district" });
    }
    else if (details.mappingRoute === '') {
      setErrorMessage({ ...errorMessage, mappingRouteError: "Please select route" });
    }
    else {
      setshowData(true);
      if (details.mappingRoute == "Grower_HIT_LLE(Storage)") {
        getGrowerHitLleRoutesData();
      }
      else if (details.mappingRoute == "Grower_HIT_IS") {
        getGrowerHitIsRoutesData();
      }
      else if (details.mappingRoute == "LLE(Storage)_Transporter_Plant") {
        getLleTransporterPlantRoutesData();
      }
      else if (details.mappingRoute == "LLE(Storage)_Transporter_IS") {
        getLleTransporterIsRoutesData();
      }
      else if (details.mappingRoute == " Grower_HIT_LLE(Chipping)_TR_Plant") {
        getGrowerHitLleTransporterPlantRoutesData();
      }
      else {
        setViewAllRouteDetails();
      }
    }
  }
return (
    <div>
      <Container fluid>
        <Row>
          <Col xs={12} md={3} className='common-internal-sidebar-col'>
            <div className="common-internal-sidebar-container">
              <ArrowBackIosNew className="arrow-icon" onClick={() => (navigate('/sidebar'))} />
            </div>
          </Col>
          <Col xs={12} md={9} className='view-route-container'>
            <Container fluid>
              <Row>
                <div className="view-all-routes-text col-padding">View All Mapping Routes</div>
                <Col xs={12} md={5} className="col-padding view-route-left">

                  <Container fluid>
                    <Row>
                      <Col xs={12} md={6} className="col-padding">
                        <div className="resource-common-label-heading">State</div>
                        <select className="resource-state-district-dropdown" name="resourceState" onChange={(e) => handleChange(e)}>
                          <option value=''>State</option>
                          {
                            chooseState?.map((statename) =>
                              <option value={statename}>{titleCase(statename)}</option>)
                          }
                        </select>
                        <div className='commonErrorMsg' >{errorMessage.stateError}</div>
                      </Col>
                      <Col xs={12} md={6} className="col-padding">
                        <div className="resource-common-label-heading">District</div>
                        <select className="resource-state-district-dropdown" name='resourceDistrict' onChange={(e) => handleChange(e)}>
                          <option value=''>District</option>
                          {
                            chooseDistrict?.map((districtname) =>
                              <option value={districtname}>{titleCase(districtname)}</option>)

                          }
                        </select>
                        <div className='commonErrorMsg' >{errorMessage.districtError}</div>
                      </Col>
                    </Row>
                  </Container>
                </Col>
                <Col xs={12} md={7} className="col-padding">
                  <div className="resource-common-label-heading">MappingRoute</div>
                  <Container fluid>
                    <Row>
                      <Col xs={12} md={7} className="col-padding">
                        <select className="view-route-dropdown" name="mappingRoute" onChange={(e) => handleChange(e)}>
                          <option value=''>Route</option>
                          {
                            chooseRoute?.map((item) =>
                              <option value={item}>{item}</option>)

                          }
                        </select>
                        <div className='commonErrorMsg' >{errorMessage.mappingRouteError}</div>
                      </Col>
                      <Col xs={12} md={5} className="col-padding">
                        <button className="view-route-proceed-button" type="submit" onClick={(e) => onProceedRoute(e)}>Proceed</button>
                      </Col>
                    </Row>
                  </Container>

                </Col>
                {(viewAllRouteDetails && showData) ?
                  <Col xs={12} md={12} className='common-table-col col-padding'>
                    <div className='view-route-common-table-div'>
                      <Table responsive className="common-table" striped>
                        <>
                          <thead>
                            <tr>
                              {viewAllRouteDetails[0]?.growerUrn &&
                                <>
                                  <th className='common-table-heading-text'>Grower Name</th>
                                  <th className='common-table-heading-text'>Grower URN</th>
                                  {/* <th className='common-table-heading-text'>Grower Address</th> */}
                                </>
                              }
                              {viewAllRouteDetails[0]?.hitUrn &&
                                <>
                                  <th className='common-table-heading-text'>HIT Name</th>
                                  <th className='common-table-heading-text'>HIT URN</th>
                                  {/* <th className='common-table-heading-text'>HIT Address</th> */}
                                </>
                              }
                              {viewAllRouteDetails[0]?.lleUrn &&
                                <>
                                  <th className='common-table-heading-text'>LLE Name</th>
                                  <th className='common-table-heading-text'>LLE URN</th>
                                  {/* <th className='common-table-heading-text'>LLE Address</th> */}
                                </>
                              }
                              {viewAllRouteDetails[0]?.isUrn &&
                                <>
                                  <th className='common-table-heading-text'>IS Name</th>
                                  <th className='common-table-heading-text'>IS URN</th>
                                  {/* <th className='common-table-heading-text'>IS Address</th> */}
                                </>
                              }
                              {viewAllRouteDetails[0]?.transporterUrn &&
                                <>
                                  <th className='common-table-heading-text'>Transporter Name</th>
                                  <th className='common-table-heading-text'>Transporter URN</th>
                                  {/* <th className='common-table-heading-text'>Transporter Address</th> */}
                                </>
                              }
                              {viewAllRouteDetails[0]?.plantUrn &&
                                <>
                                  <th className='common-table-heading-text'>Plant Name</th>
                                  <th className='common-table-heading-text'>Plant URN</th>
                                  {/* <th className='common-table-heading-text'>Plant Address</th> */}
                                </>
                              }
                            </tr>
                          </thead>
                          <tbody>
                            {
                              viewAllRouteDetails &&
                              viewAllRouteDetails?.map((item, i) => (
                                <tr>
                                  {item?.growerUrn &&
                                    <>
                                      <td className='common-table-text'>{item?.growerName}</td>
                                      <td className='common-table-text'>{item.growerUrn}</td>
                                      {/* <td className='common-table-text'>{item.growerAddress
                                  }</td> */}
                                    </>
                                  }
                                  {item?.hitUrn &&
                                    <>
                                      <td className='common-table-text'>{item?.hitName}</td>
                                      <td className='common-table-text'>{item?.hitUrn}</td>
                                      {/* <td className='common-table-text'>{item.hitAddress
                                  }</td> */}
                                    </>
                                  }
                                  {item?.lleUrn &&
                                    <>
                                      <td className='common-table-text'>{item?.lleName
                                      }</td>
                                      <td className='common-table-text'>{item?.lleUrn
                                      }</td>
                                      {/* <td className='common-table-text'>{item.lleAddress
                                  }</td> */}
                                    </>
                                  }
                                  {item?.isUrn &&
                                    <>
                                      <td className='common-table-text'>{item?.isName
                                      }</td>
                                      <td className='common-table-text'>{item?.isUrn
                                      }</td>
                                      {/* <td className='common-table-text'>{item.isAddress
                                  }</td> */}
                                    </>
                                  }
                                  {item?.transporterUrn &&
                                    <>
                                      <td className='common-table-text'>{item?.transporterName
                                      }</td>
                                      <td className='common-table-text'>{item?.transporterUrn
                                      }</td>
                                      {/* <td className='common-table-text'>{item.transporterAddress
                                  }</td> */}
                                    </>
                                  }
                                  {item?.plantUrn &&
                                    <>
                                      <td className='common-table-text'>{item?.plantName
                                      }</td>
                                      <td className='common-table-text'>{item?.plantUrn
                                      }</td>
                                      {/* <td className='common-table-text'>{item.plantAddress
                                  }</td> */}
                                    </>
                                  }
                                </tr>
                              ))
                            }
                          </tbody>
                        </>
                      </Table>
                    </div>
                  </Col> : showData ? <Col xs={12} md={9} className="NoContentCol"><div className='NodataAvailableDiv'>
                    No Data Available
                  </div></Col> : null}
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ViewAllMappingRoutes;
